import { useCallback, useState } from 'react'
import { IUploadStatus } from '@/hooks/useUpload'
import { getHomeworkAwsUploadUrl } from '@/services/class'
import { multipartUpload } from '@/services/s3'

type UploadStateInfo = {
  status: IUploadStatus
  message: string
}

export const useOSSPut = () => {
  const [uploadProgress, setUploadProgress] = useState(0)
  const [uploadStatus, setUploadStatus] = useState<UploadStateInfo>({
    status: 'init',
    message: 'Init',
  })

  const reupload = useCallback(() => {
    setUploadStatus({
      status: 'init',
      message: 'Init',
    })
    setUploadProgress(0)
  }, [])

  // 서버에서 S3 업로드 주소(presigned URL)를 받아 올립니다. 자격증명은 브라우저로
  //   내려오지 않습니다. `prefix` 는 서버의 허용 목록에 있는 것만 쓸 수 있고,
  //   그 밖의 값은 서버가 기본값 `courseware/` 로 되돌립니다.
  const handleUploadKr = useCallback(
    async (file, fileName: string, prefix?: string) => {
      setUploadStatus({ status: 'uploading', message: 'Uploading...' })
      setUploadProgress(0)
      try {
        const { data } = await getHomeworkAwsUploadUrl(fileName, prefix)
        if (data && data.data) {
          await multipartUpload(data.data, file, {
            onProgress: p => {
              setUploadProgress(p * 100)
            },
          })
          setUploadProgress(100)
          setUploadStatus({
            status: 'completed',
            message: 'Upload Completed',
          })

          return data.data.split('?')[0]
        }
      } catch (e) {
        setUploadStatus({
          status: 'error',
          message: 'Upload Failed, Please try again',
        })
      }
    },
    []
  )

  return {
    uploadStatus,
    uploadProgress,
    reupload,
    handleUploadKr,
  }
}
